/*
$(function () {
  // タブの切り替え処理を関数化
  function switchTab(pageType, isInitial = false) {
    // メインタブの切り替え
    $('.tab-seminar-item').removeClass('is-active');

    if (pageType === 'internship') {
      $('.tab-seminar-internship').addClass('is-active');
      // コンテンツの切り替え
      $('.content__seminar').removeClass('is-show');
      $('.content__internship').addClass('is-show');
    } else {
      $('.tab-seminar-seminar').addClass('is-active');
      // コンテンツの切り替え
      $('.content__internship').removeClass('is-show');
      $('.content__seminar').addClass('is-show');
    }

    // 初期表示時はURLの更新をスキップ
    if (!isInitial) {
      var newURL = window.location.pathname + '?id=' + pageType;
      window.history.pushState('', '', newURL);

      // dataLayerにページビューイベントをプッシュ
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'virtualPageview',
        'virtualPagePath': newURL,
        'virtualPageTitle': pageType === 'seminar' ? 'セミナー・説明会' : 'インターンシップ・仕事体験'
      });
    }
  }

  // 初期表示時の処理
  var urlParams = new URLSearchParams(window.location.search);
  var pageType = urlParams.get('id');

  // URLパラメータがinternshipの場合
  if (pageType === 'internship') {
    switchTab('internship', true);  // 第2引数にtrueを渡す
  }

  // メインタブクリック時の処理
  $('.tab-seminar-item').on('click', function () {
    var pageType = $(this).hasClass('tab-seminar-seminar') ? 'seminar' : 'internship';
    switchTab(pageType, false);
  });
});

$(function () {

  $('.subtab-seminar-item').on('click', function () {
    let index = $('.subtab-seminar-item').index(this);

    $('.subtab-seminar-item').removeClass('is-active');
    $(this).addClass('is-active');
    $('.subtab-seminar-content').removeClass('is-show');
    $('.subtab-seminar-content').eq(index).addClass('is-show');
  });
  $('.tab-seminar-item').on('click', function () {
    let index = $('.tab-seminar-item').index(this);

    $('.tab-seminar-item').removeClass('is-active');
    $(this).addClass('is-active');
    $('.tab-seminar-content').removeClass('is-show');
    $('.tab-seminar-content').eq(index).addClass('is-show');
  });
  $('.subtab-seminar-item').on('click', function () {
    let index = $('.subtab-seminar-item').index(this);

    $('.subtab-seminar-item').removeClass('is-active');
    $(this).addClass('is-active');
    $('.subtab-seminar-content').removeClass('is-show');
    $('.subtab-seminar-content').eq(index).addClass('is-show');
  });
  $('.subtab-internship-item').on('click', function () {
    let index = $('.subtab-internship-item').index(this);

    $('.subtab-internship-item').removeClass('is-active');
    $(this).addClass('is-active');
    $('.subtab-internship-content').removeClass('is-show');
    $('.subtab-internship-content').eq(index).addClass('is-show');
  });

});
*/

$(function () {
  function switchTab(pageType, business = null, isInitial = false) {
    $('.tab-seminar-item').removeClass('is-active');

    if (pageType === 'internship') {
      $('.tab-seminar-internship').addClass('is-active');
      $('.content__seminar').removeClass('is-show');
      $('.content__internship').addClass('is-show');

      if (business) {
        // インターンシップのサブタブとコンテンツの制御
        $('.subtab-internship-item').removeClass('is-active');
        $('.subtab-internship-content').removeClass('is-show');
        $(`.subtab-internship-item.subtab__${business}`).addClass('is-active');
        // クラス名に基づいてコンテンツを表示
        $(`.content__internship .subcontent-seminar-${business}`).addClass('is-show');
      }
    } else {
      $('.tab-seminar-seminar').addClass('is-active');
      $('.content__internship').removeClass('is-show');
      $('.content__seminar').addClass('is-show');

      if (business) {
        // セミナーのサブタブとコンテンツの制御
        $('.subtab-seminar-item').removeClass('is-active');
        $('.subtab-seminar-content').removeClass('is-show');
        $(`.subtab-seminar-item.subtab__${business}`).addClass('is-active');
        // クラス名に基づいてコンテンツを表示
        $(`.content__seminar .subcontent-seminar-${business}`).addClass('is-show');
      }
    }

    if (!isInitial) {
      let newURL = window.location.pathname + '?event=' + pageType;
      if (business) {
        newURL += '&business=' + business;
      }
      window.history.pushState('', '', newURL);

      if (typeof gtag === 'function') {
        gtag('event', 'page_view');
      }
    }
  }

  // 初期表示時の処理
  var urlParams = new URLSearchParams(window.location.search);
  var initialPageType = urlParams.get('event') || 'seminar';
  var initialBusiness = urlParams.get('business');

  switchTab(initialPageType, initialBusiness, true);

  $('.tab-seminar-item').on('click', function () {
    var pageType = $(this).hasClass('tab-seminar-seminar') ? 'seminar' : 'internship';
    switchTab(pageType, null, false);
  });

  $('.subtab-seminar-item, .subtab-internship-item').on('click', function () {
    let business = '';
    if ($(this).hasClass('subtab__hotel')) business = 'hotel';
    else if ($(this).hasClass('subtab__dormitory') || $(this).hasClass('subtab__sogo')) business = 'dormitory';
    else if ($(this).hasClass('subtab__welfare') || $(this).hasClass('subtab__kaigo')) business = 'welfare';

    let isInternship = $(this).hasClass('subtab-internship-item');
    let pageType = isInternship ? 'internship' : 'seminar';
    switchTab(pageType, business, false);
  });

  window.addEventListener('popstate', function () {
    var urlParams = new URLSearchParams(window.location.search);
    var pageType = urlParams.get('event') || 'seminar';
    var business = urlParams.get('business');
    switchTab(pageType, business, true);
  });
});
